import { Trans } from '@lingui/react'
import type { FC } from 'react'

import QuerySuggestionsList from 'shared/experiments/components/AfterQuerySuggestLayer/QuerySuggestionsList'
import RedirectsList from 'shared/experiments/components/AfterQuerySuggestLayer/RedirectsList'
import {
  AFTER_QUERY_SUGGEST_LAYER,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { useGetExperimentNamePerTenant } from 'shared/experiments/utils/tenantBasedExperimentsUtils'
import MountPoints from 'shared/utils/mountPoints'
import Experiment from 'views/components/utils/optimizely/Experiment'
import Variant from 'views/components/utils/optimizely/Variant'

export type RedirectData = Array<{
  redirectTarget: string
  type: string
  suggestText?: string
}>

const AfterQuerySuggestLayer: FC<{
  mountPoints: MountPoints
  querySuggestions: string[]
  redirectData: RedirectData
  shopUrl: string
}> = ({ mountPoints, shopUrl, querySuggestions, redirectData }) => {
  const experimentName = useGetExperimentNamePerTenant(
    AFTER_QUERY_SUGGEST_LAYER
  )

  const redirectCategories: RedirectData = []
  const redirectLandingPages: RedirectData = []

  redirectData.map(redirect => {
    if (redirect.type === 'redirect') {
      redirectLandingPages.push(redirect)
    } else if (redirect.type === 'category') {
      redirectCategories.push(redirect)
    }
  })

  return (
    <Experiment preventActivation name={experimentName}>
      <Variant name={EXPERIMENT_VARIATION.DEFAULT}>
        {() => {
          return (
            <>
              {redirectLandingPages.length > 0 && (
                <>
                  <div className="u-font-weight--bold u-padding--bottom">
                    <Trans id="general.label.search" />
                  </div>
                  <ul className="a-list-reset u-margin--bottom">
                    <RedirectsList
                      redirectData={redirectLandingPages}
                      shopUrl={shopUrl}
                    />
                  </ul>
                </>
              )}
            </>
          )
        }}
      </Variant>
      <Variant name={EXPERIMENT_VARIATION.V1}>
        {() => {
          return (
            <div>
              <div className="u-font-weight--bold u-padding--bottom">
                <Trans id="general.label.search" />
              </div>
              <ul className="a-list-reset u-margin--bottom">
                {querySuggestions.length > 0 && (
                  <QuerySuggestionsList
                    querySuggestions={querySuggestions}
                    mountPoints={mountPoints}
                  />
                )}
                {redirectLandingPages.length > 0 && (
                  <RedirectsList
                    redirectData={redirectLandingPages}
                    shopUrl={shopUrl}
                  />
                )}
              </ul>
            </div>
          )
        }}
      </Variant>
      <Variant name={EXPERIMENT_VARIATION.V2}>
        {() => {
          return (
            <div className="l-flex l-flex--start">
              <div className="u-padding--right">
                <div className="u-font-weight--bold u-padding--bottom">
                  <Trans id="general.label.search" />
                </div>
                <ul className="a-list-reset u-margin--bottom">
                  {querySuggestions.length > 0 && (
                    <QuerySuggestionsList
                      querySuggestions={querySuggestions}
                      mountPoints={mountPoints}
                    />
                  )}
                  {redirectLandingPages.length > 0 && (
                    <RedirectsList
                      redirectData={redirectLandingPages}
                      shopUrl={shopUrl}
                    />
                  )}
                </ul>
              </div>
              {redirectCategories.length > 0 && (
                <div>
                  <div className="u-font-weight--bold u-padding--bottom">
                    <Trans id="general.label.categories" />
                  </div>
                  <ul className="a-list-reset u-margin--bottom">
                    <RedirectsList
                      redirectData={redirectCategories}
                      shopUrl={shopUrl}
                      lpRedirect={false}
                    />
                  </ul>
                </div>
              )}
            </div>
          )
        }}
      </Variant>
    </Experiment>
  )
}

export default AfterQuerySuggestLayer
